import reactHelmet from 'react-helmet';
// This wrapper file exists to make our usage of react-helmet cleaner.

const Helmet = reactHelmet;

export default Helmet;
